import { RageClient } from './RageClient';
import { RageClientStub } from './RageClientStub';
import { IRageClient } from './types';

const useStub =
	import.meta.env.MODE === 'development' ? !('mp' in window) : false;

export * from './decorators';
export * from './reactHooks';
export * from './services';

export const rage: IRageClient = useStub
	? new RageClientStub()
	: new RageClient();

(window as any)['globalrage'] = rage;
